import { getFormValues } from 'redux-form'
import { PERSONALIZE_VEHICLE_MODAL } from 'constant'

export const getValues = getFormValues(PERSONALIZE_VEHICLE_MODAL)
